// extracted by mini-css-extract-plugin
export var box = "Product-module--box--qk2Cy";
export var boxWrapper = "Product-module--boxWrapper--37tFi";
export var hoverProduct = "Product-module--hoverProduct--grmSH";
export var boxButton = "Product-module--boxButton--K7-Qm";
export var innerButton = "Product-module--innerButton--2atih";
export var iconContainer = "Product-module--iconContainer--EFSEc";
export var description = "Product-module--description--uM05s";